$(".search-replacement-parts-sorter-first button.search-button.shop_Replacement_part.button").on('click', function() {
  var choose_year= $(".choose_year option:selected").val();
  var choose_model_selected= $(".choose_model option:selected").val();
  //console.log("choose_year==="+choose_year);
  //  console.log("choose_model_selected==="+choose_model_selected);

  var choose_seats= $(".choose_seats option:selected").val();
  var Choose_Seats_Configuration= $(".Choose_Seats_Configuration option:selected").val();
  var Choose_Your_Interior_Meterial= $(".Choose_Your_Interior_Meterial option:selected").val();
  var Choose_Exterior_Material= $(".Choose_Exterior_Material option:selected").val();

  var choose_year= $(".choose_year option:selected").val();
  var choose_model_selected= $(".choose_model option:selected").val();

  if( choose_year=='Choosen' && choose_model_selected =='Choosen' ){

    if( choose_seats=='Choosen' || Choose_Seats_Configuration =='Choosen'  || Choose_Your_Interior_Meterial =='Choosen'   || Choose_Exterior_Material =='Choosen' ){
    }
    else{
      setTimeout(function(){ 
        $(".Choose_all_four").trigger("change");
        //         console.log("choose_seats====="+choose_seats);
        //         console.log("Choose_Seats_Configuration====="+Choose_Seats_Configuration);
        //         console.log("Choose_Your_Interior_Meterial====="+Choose_Your_Interior_Meterial);
        //         console.log("Choose_Exterior_Material====="+Choose_Exterior_Material);
        //         console.log("choose_year====="+choose_year);
        //         console.log("choose_model_selected====="+choose_model_selected);
      },1210);


    }


  }






  if( choose_year=='Choosen' || choose_model_selected =='Choosen' ){
    $(".search-replacement-parts-sorter-first .please_select_all").show();
    $(".search-replacement-parts-sorter-second .please_select_all").hide();
  }
  else{
    $(".please_select_all").hide();
    $(".Custom_Loading").show();
    $("body").addClass("opacity_change");
    setTimeout(function(){   
      if( $(".icon_with_image:visible").length=='0'){
        $(".no_product_find").show();
        console.log($(".icon_with_image:visible").length);
        console.log("show");
      }
      else{
        $(".no_product_find").hide();
        //   console.log($(".icon_with_image:visible").length);
        // console.log("hide");
      }
    },1200);
  }
  setTimeout(function(){ 
    $(".Custom_Loading").hide();
    $("body").removeClass("opacity_change");
    $(".icon_with_image").each(function(){
      var year= $(this).attr("data-year");
      var modal = $(this).attr("data-model");

      var Final_year = year.includes(choose_year);
      var Final_modal = modal.includes(choose_model_selected);
      if( Final_year && Final_modal ){
        $(this).show();
      }
      else{
        $(this).hide();
      }
    });
  },1000);



});

$(".search-replacement-parts-sorter-first button.search-button.reset.button").on('click', function () {
  var choose_year = $(".choose_year option:first").val();
  var choose_model_selected = $(".choose_model option:first").val();
  $(".choose_year").val(choose_year);
  $(".choose_model").val(choose_model_selected);

  $(".Choose_all_four").trigger("change");

  $(".please_select_all").hide();
  $(".icon_with_image").each(function(){
    $(this).hide();
  });
  $('select.choose_year_model option').prop('disabled', false);
});

//$('select.choose_year_model').change();
const modeMapping = [
  {
    model: 'Avila',
    year: '2020,2021',
    seats: 3,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Fairfax',
    year: '2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Fairfax',
    year: '2019,2020,2021',
    seats: 6,
    lounge: 'Has no Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Miramar L',
    year: '2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Miramar NL',
    year: '2020,2021',
    seats: 6,
    lounge: 'Has no Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Ventura',
    year: '2017,2018,2019,2020,2021',
    seats: 6,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Aryana',
    year: '2015,2016,2017,2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Benicia',
    year: '2013,2014,2015,2016,2017,2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'No Siding'
  },
  {
    model: 'Brighton L',
    year: '2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Brighton NL',
    year: '2018,2019,2020,2021',
    seats: 6,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Calavera',
    year: '2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Grayson',
    year: '2017,2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'No Siding'
  },
  {
    model: 'Maderas L',
    year: '2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Maderas NL',
    year: '2018,2019,2020,2021',
    seats: 6,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Montara',
    year: '2020,2021',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Montecito',
    year: '2015,2016,2017,2018,2019,2020,2021',
    seats: 7,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Newporter 3.0',
    year: '2016,2017,2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Newporter',
    year: '2012',
    seats: 5,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Transport 3.0',
    year: '2019,2020,2021',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Transport II',
    year: '2014,2015,2016,2017,2018',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Transport',
    year: '2012,2013,2014,2015',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  }
];

const modelMappingAltered = [
  {
    model: 'Aryana',
    year: '2015,2016,2017,2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Avila',
    year: '2020,2021',
    seats: 3,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Benicia',
    year: '2013,2014,2015,2016,2017,2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'No Siding'
  },
  {
    model: 'Brighton',
    year: '2018,2019,2020,2021',
    seats: '5,6',
    lounge: 'Has a Lounge Seat,Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Calavera',
    year: '2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Fairfax',
    year: '2019,2020,2021',
    seats: '5,6',
    lounge: 'Has a Lounge Seat,Has no Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Grayson',
    year: '2017,2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'No Siding'
  },
  {
    model: 'Maderas',
    year: '2018,2019,2020,2021',
    seats: '5,6',
    lounge: 'Has a Lounge Seat,Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Miramar',
    year: '2019,2020,2021',
    seats: '5,6',
    lounge: 'Has a Lounge Seat,Has no Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  },
  {
    model: 'Montara',
    year: '2020,2021',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Montecito',
    year: '2015,2016,2017,2018,2019,2020,2021',
    seats: 7,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Newporter',
    year: '2012,2016,2017,2018,2019,2020,2021',
    seats: 5,
    lounge: 'Has no Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Transport',
    year: '2012,2013,2014,2015,2016,2017,2018,2019,2020,2021',
    seats: 4,
    lounge: 'Has a Lounge Seat',
    interior: 'Rotomolded',
    siding: 'Has Siding'
  },
  {
    model: 'Ventura',
    year: '2017,2018,2019,2020,2021',
    seats: 6,
    lounge: 'Has a Lounge Seat',
    interior: 'Acrylic',
    siding: 'Has Siding'
  }
];

$('select.choose_year').change(function() {
  var value = this.value;
  if (value == 'Choosen') {
    $('select.choose_model option').prop('disabled', false);
    return;
  }
  $('select.choose_model option').prop('disabled', false);
  var disabledModels = modelMappingAltered.filter( function(item) {
    return item.year.indexOf(value) == -1;
  });
  console.log(disabledModels);
  disabledModels.forEach(function (item) {
    //console.log('disable: select.choose_model option[value="' + item.model + '"]');
    $('select.choose_model option[value="' + item.model + '"]').prop('disabled', true);
    /*$('select.choose_model option').each(function() {
      if (item.model.indexOf(this.value) != -1) {
        $(this).prop('disabled', true);
      }
    });*/
  });
});

$('select.choose_model').change(function() {
  var value = this.value;
  if (value == 'Choosen') {
    $('select.choose_year option').prop('disabled', false);
    return;
  }
  var okYears = modelMappingAltered.filter( function(item){
    // Models in the map have longer, more detailed names
    return item.model.indexOf(value) != -1;
  });

  console.log(okYears);

  $('select.choose_year option').prop('disabled', true);

  okYears.forEach(function(item) {
    years = item.year.split(',');
    console.log(years);
    years.forEach(function(year) {
      console.log('select.choose_year option[value="' + year + '"]');
      $('select.choose_year option[value="' + year + '"]').prop('disabled', false);
    })
    $('select.choose_year option[value="Choosen"]').prop('disabled', false);
  });
});


$(".search-replacement-parts-sorter-second button.search-button.shop_Replacement_part.button").on('click', function() {
  var choose_seats= $(".choose_seats option:selected").val();
  var Choose_Seats_Configuration= $(".Choose_Seats_Configuration option:selected").val();
  var Choose_Your_Interior_Meterial= $(".Choose_Your_Interior_Meterial option:selected").val();
  var Choose_Exterior_Material= $(".Choose_Exterior_Material option:selected").val();

  var choose_year= $(".choose_year option:selected").val();
  var choose_model_selected= $(".choose_model option:selected").val();


  if( choose_seats=='Choosen' || Choose_Seats_Configuration =='Choosen'  || Choose_Your_Interior_Meterial =='Choosen'   || Choose_Exterior_Material =='Choosen' ){
    $(".search-replacement-parts-sorter-first .please_select_all").hide();
    $(".search-replacement-parts-sorter-second .please_select_all").show();
  }
  else{
    $(".please_select_all").hide();
    $(".Custom_Loading").show();
    $("body").addClass("opacity_change");
    setTimeout(function(){   
      if( $(".icon_with_image:visible").length=='0'){
        $(".no_product_find").show();
      }
      else{
        $(".no_product_find").hide();
      }
    },1200);
  }

  setTimeout(function(){ 
    $(".Custom_Loading").hide();
    $("body").removeClass("opacity_change");
    if(choose_year == 'Choosen' || choose_model_selected == 'Choosen' ){
      //   console.log("1");  
      $(".icon_with_image").each(function(){
        var seat= $(this).attr("data-seat");
        var seat_config = $(this).attr("data-seat_config");
        var interior = $(this).attr("data-interior");
        var exterior = $(this).attr("data-exterior");

        var Final_seat = seat.includes(choose_seats);
        var Final_seat_config = seat_config.includes(Choose_Seats_Configuration);
        var Final_interior = interior.includes(Choose_Your_Interior_Meterial);
        var Final_exterior = exterior.includes(Choose_Exterior_Material);

        if( Final_seat && Final_seat_config  && Final_interior  && Final_exterior){
          $(this).show();
        }
        else{
          $(this).hide();
        }
      });

    }
    else{
      //     console.log("2");
    }



  },1000);



});
$(".search-replacement-parts-sorter-second button.search-button.reset.button").on('click', function () {

  var choose_seats= $(".choose_seats option:first").val();
  var Choose_Seats_Configuration= $(".Choose_Seats_Configuration option:first").val();
  var Choose_Your_Interior_Meterial= $(".Choose_Your_Interior_Meterial option:first").val();
  var Choose_Exterior_Material= $(".Choose_Exterior_Material option:first").val();
  
  $(".choose_seats").val(choose_seats);
  $(".Choose_Seats_Configuration").val(Choose_Seats_Configuration);
  $(".Choose_Your_Interior_Meterial").val(Choose_Your_Interior_Meterial);
  $(".Choose_Exterior_Material").val(Choose_Exterior_Material);

  $(".please_select_all").hide();
  $(".icon_with_image").each(function(){
    $(this).hide();
  });
  $('select.Choose_all_four option').prop('disabled', false);
});

function filterChooseAllFour() {
  var choose_seats= $(".choose_seats option:selected").val();
  var Choose_Seats_Configuration= $(".Choose_Seats_Configuration option:selected").val();
  var Choose_Your_Interior_Meterial= $(".Choose_Your_Interior_Meterial option:selected").val();
  var Choose_Exterior_Material= $(".Choose_Exterior_Material option:selected").val();

  var any_seat = choose_seats == 'Choosen';
  var any_seat_config = Choose_Seats_Configuration == 'Choosen';
  var any_interior = Choose_Your_Interior_Meterial == 'Choosen';
  var any_exterior = Choose_Exterior_Material == 'Choosen';

  var availableSeat = [];
  var availableSeat_config = [];
  var availableInterior = [];
  var availableExterior = [];

  // only check filters for models
  $(".icon_with_image[data-mode!='']").each(function(){

    var seat= $(this).attr("data-seat");
    var seat_config = $(this).attr("data-seat_config");
    var interior = $(this).attr("data-interior");
    var exterior = $(this).attr("data-exterior");

    var Final_seat = any_seat || seat.includes(choose_seats);
    var Final_seat_config = any_seat_config || seat_config.includes(Choose_Seats_Configuration);
    var Final_interior = any_interior || interior.includes(Choose_Your_Interior_Meterial);
    var Final_exterior = any_exterior || exterior.includes(Choose_Exterior_Material);

    if( Final_seat && Final_seat_config  && Final_interior  && Final_exterior){
      //$(this).show();
      seat = seat.split(',');
      seat.forEach(function(seatItem) {
        if (!availableSeat.includes(seatItem) && seatItem != '') {
          availableSeat.push(seatItem);
        }
      });

      seat_config = seat_config.split(',');
      seat_config.forEach(function(seat_configItem) {
        if (!availableSeat_config.includes(seat_configItem) && seat_configItem != '') {
          availableSeat_config.push(seat_configItem);
        }
      });

      interior = interior.split(',');
      interior.forEach(function(interiorItem) {
        if (!availableInterior.includes(interiorItem) && interiorItem != '') {
          availableInterior.push(interiorItem);
        }
      });
      
      exterior = exterior.split(',');
      exterior.forEach(function(exteriorItem) {
        if (!availableExterior.includes(exteriorItem) && exteriorItem != '') {
          availableExterior.push(exteriorItem);
        }
      });
    }
    else{
    }
  });
  console.log(availableSeat);
  console.log(availableSeat_config);
  console.log(availableInterior);
  console.log(availableExterior);
  
  $('.Choose_all_four option[value!="Choosen"]').prop('disabled', true);

/**
  var any_seat = choose_seats == 'Choosen';
  var any_seat_config = Choose_Seats_Configuration == 'Choosen';
  var any_interior = Choose_Your_Interior_Meterial == 'Choosen';
  var any_exterior = Choose_Exterior_Material == 'Choosen';
 */
  if (!any_seat && any_seat_config && any_interior && any_exterior) {
    $('.choose_seats option').prop('disabled', false);
  } else {
    availableSeat.forEach(function(val) {
      $('.choose_seats option[value="' + val + '"]').prop('disabled', false);
    });
  }
  

  // keep the lounge options enabled always
  $('.Choose_Seats_Configuration option').prop('disabled', false);
  
  /*
  // disable logic to enable/disable lounge options
  if (any_seat && !any_seat_config && any_interior && any_exterior) {
    $('.Choose_Seats_Configuration option').prop('disabled', false);
  } else{
    availableSeat_config.forEach(function(val) {
      $('.Choose_Seats_Configuration option[value="' + val + '"]').prop('disabled', false);
    });
  }
  */

  if (any_seat && any_seat_config && !any_interior && any_exterior) {
    $('.Choose_Your_Interior_Meterial option').prop('disabled', false);
  } else {
    availableInterior.forEach(function(val) {
      $('.Choose_Your_Interior_Meterial option[value="' + val + '"]').prop('disabled', false);
    });
  }
  
  if (any_seat && any_seat_config && any_interior && !any_exterior) {
    $('.Choose_Exterior_Material option').prop('disabled', false);
  } else {
    availableExterior.forEach(function(val) {
      $('.Choose_Exterior_Material option[value="' + val + '"]').prop('disabled', false);
    });
  }
  

}

function filterSeats(seats) {

}

function filterChooseAllFour2() {
  var selectboxes = [
    {
      type: 'seat',
      selectClass: '.choose_seats',
      dataAttr: 'data-seat',
      value: '',
      availableValues: {
        seat: [],
        seat_config: [],
        interior: [],
        exterior: []
      },
    },
    {
      type: 'seat_config',
      selectClass: '.Choose_Seats_Configuration',
      dataAttr: 'data-seat_config',
      value: '',
      availableValues: {
        seat: [],
        seat_config: [],
        interior: [],
        exterior: []
      },
    },
    {
      type: 'interior',
      selectClass: '.Choose_Your_Interior_Meterial',
      dataAttr: 'data-interior',
      value: '',
      availableValues: {
        seat: [],
        seat_config: [],
        interior: [],
        exterior: []
      },
    },
    {
      type: 'exterior',
      selectClass: '.Choose_Exterior_Material',
      dataAttr: 'data-exterior',
      value: '',
      availableValues: {
        seat: [],
        seat_config: [],
        interior: [],
        exterior: []
      },
    },
  ];
  selectboxes.forEach(function(selectbox) {
    selectbox.value = $(selectbox.selectClass + " option:selected").val();
    selectboxes.forEach(function(select) {
      //if (selectbox.type != select.type) {
        $(".icon_with_image[data-model != '']").each(function(){
          console.log(select);
          console.log(select.dataAttr);
          var dataVal = $(this).attr(select.dataAttr);
          var anyVal = dataVal == 'Choosen';

          console.log(this);
          console.log(dataVal);
          dataVal = dataVal.split(',');
          dataVal.forEach(function(val) {
            if (val != '' && !selectbox.availableValues[select.type].includes(val)) {
              selectbox.availableValues[select.type].push(val);
            }
          });
        });
      //}
    });
    
  });
  console.log(selectboxes);
}


$('select.Choose_all_four').change(filterChooseAllFour);
$('select.Choose_all_four').change(filterChooseAllFour2);




$(document).on("click",".custom_input_checkbox_title_click",function(e){
  e.preventDefault();
  $(this).parent(".input-checkbox-wrapper").find("input").prop("checked", true);
  console.log($(this).parent(".input-checkbox-wrapper").find("input").val());
});

// product Page Custom Variant Categories JS (22/12/2020)

$(document).on("click",".form-add-to-cart-product .input-checkbox-title",function(){
  var favorite = [];

  setTimeout(function(){ 
    jQuery.each($(".upsell_section .ProductItem .input-checkbox:checked"), function(){
      favorite.push($(this).val());

    });

    var fadvorite= favorite.join(" / " ) ;

    jQuery(".commona").each(function(){
      var title =$(this).attr("data-title");
      var id= $(this).attr("data-variant-id");
      var data= $(this).attr("data-available");
      if (fadvorite.match(title)) {
        jQuery (this).closest(".form-add-to-cart-product").find(".add-to-cart-id").val(id);
        if(data == 'yes'){
          var btn= jQuery (this).closest(".form-add-to-cart-product").find(".button").val("Add To Cart");
          jQuery (this).closest(".form-add-to-cart-product").find(".button").removeClass("disabled");
          jQuery (this).closest(".form-add-to-cart-product").find(".button").removeAttr("disabled","disabled");
        }
        else{
          var soldout= jQuery (this).closest(".form-add-to-cart-product").find(".button").val("Sold Out");
          jQuery (this).closest(".form-add-to-cart-product").find(".button").addClass("disabled");
          jQuery (this).closest(".form-add-to-cart-product").find(".button").attr("disabled","disabled");
        }
      }

    });}, 200);

});
// shop_Replacement_part click pdp
$("a.shop_Replacement_part.button").click(function(e){
  e.preventDefault();
  var height=$(".main-header-wrapper").height();
  $('html, body').animate({
    scrollTop: $("#shop_Replacement_part").offset().top-height
  }, 2000);
});



$(".custom_trigger_on_click").click(function(){
  var path= $(this).attr("data-image");
  $(this).parents(".icon_with_image").find(".product_image_h").attr("src",path);
});

$(".icon_with_image").each(function(){
  $(this).find(".custom_trigger_on_click").first().trigger("click");
});